import { navigate } from "gatsby"
import { useEffect } from "react"

/**
 * NOTE: This hook is used to get the elements and navigate the page like a SPA rather than a full refresh.
 *
 * @param {string} selectors - The selectors to which the click event is attached.
 * @param {string} altNavigationLink - The alternative navigation link.
 * @param {Array} dependencies - The dependencies to which the click event is attached.
 * @returns {void}
 */
export const useToggleLink = (
  selectors,
  altNavigationLink,
  dependencies = []
) => {
  useEffect(() => {
    const tags = document.querySelectorAll(selectors)

    if (tags) {
      tags.forEach(tag => {
        tag.addEventListener("click", event => {
          event.preventDefault()
          if (event.ctrlKey || event.metaKey) {
            window.open(
              `${
                event.currentTarget.href
                  ? event.currentTarget.href
                  : altNavigationLink
              }`,
              "_blank"
            )
          } else {
            navigate(
              `${
                event.currentTarget.href
                  ? event.currentTarget.href
                  : altNavigationLink
              }`
            )
          }
        })
      })
    }
  }, [...dependencies])
}
